import { api } from "./apiSlice";

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export interface EquipmentCalibrationLog {
  id: string;
  calibrationDate: string;
  result: string;
}

export interface EquipmentMaintenanceLog {
  id: string;
  maintenanceDate: string;
  type: string;
}

export interface Equipment {
  id: string;
  type: string;
  serialNumber: string | null;
  manufacturer: string | null;
  model: string | null;
  purchaseDate: string | null;
  warrantyExpiry: string | null;
  locatedMedEstId: string;
  status: string;
  medEstName?: string;
  medEstAddress?: string;
  calibrationLogs?: EquipmentCalibrationLog[];
  maintenanceLogs?: EquipmentMaintenanceLog[];
}

export interface EquipmentInput {
  type: string;
  serialNumber?: string;
  manufacturer?: string;
  model?: string;
  purchaseDate?: string;
  warrantyExpiry?: string;
  locatedMedEstId: string;
  status: string;
}

export const bloodEquipmentApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBloodEquipment: builder.query<Equipment[], void>({
      query: () => "/blood-equipment",
      transformResponse: (res: ApiResponse<{ equipment: Equipment[] }>) => res.data.equipment,
      providesTags: ["BloodEquipment"],
    }),
    getBloodEquipmentById: builder.query<Equipment, string>({
      query: (id) => `/blood-equipment/${id}`,
      transformResponse: (res: ApiResponse<Equipment>) => res.data,
      providesTags: (_r, _e, id) => [{ type: "BloodEquipment", id }],
    }),
    createBloodEquipment: builder.mutation<Equipment, EquipmentInput>({
      query: (body) => ({ url: "/blood-equipment", method: "POST", body }),
      transformResponse: (res: ApiResponse<Equipment>) => res.data,
      invalidatesTags: ["BloodEquipment"],
    }),
    updateBloodEquipment: builder.mutation<Equipment, { id: string; data: Partial<EquipmentInput> }>({
      query: ({ id, data }) => ({ url: `/blood-equipment/${id}`, method: "PUT", body: data }),
      transformResponse: (res: ApiResponse<Equipment>) => res.data,
      invalidatesTags: ["BloodEquipment"],
    }),
    deleteBloodEquipment: builder.mutation<void, string>({
      query: (id) => ({ url: `/blood-equipment/${id}`, method: "DELETE" }),
      invalidatesTags: ["BloodEquipment"],
    }),
  }),
});

export const {
  useGetBloodEquipmentQuery,
  useGetBloodEquipmentByIdQuery,
  useCreateBloodEquipmentMutation,
  useUpdateBloodEquipmentMutation,
  useDeleteBloodEquipmentMutation,
} = bloodEquipmentApi;
